import Chome from '../p_company/views/Chome.vue'; // 企业 首页
import MapHome from '../p_company/components/mapPage/map.vue'; // 企业 首页地图

import ReportCharts from '../p_company/components/reportPage/reportCharts.vue'; // 企业 报表中心 数据图表
import ReportTable from '../p_company/components/reportPage/reportTable.vue'; // 企业 报表中心 数据表格
import OnlineData from '../p_company/components/reportPage/onlineData.vue'; // 企业 报表中心 在线数据
import onlineDataWater1 from '../p_company/components/reportPage/onlineDataWater1.vue'; // 企业 报表中心 在线数据
import onlineDataWater2 from '../p_company/components/reportPage/onlineDataWater2.vue'; // 企业 报表中心 在线数据
import onlineDataWater3 from '../p_company/components/reportPage/onlineDataWater3.vue'; // 企业 报表中心 在线数据
import ReportDaily from '../p_company/components/reportPage/reportDaily.vue'; // 企业 报表中心 日报
import ManualInput from '../p_company/components/reportPage/dataManualInput.vue'; //手工填报气

import WarnRule from '../p_company/components/warnPage/warnRule.vue'; // 企业 告警中心 规则
import WarnCharts from '../p_company/components/warnPage/warnCharts.vue'; // 企业 告警中心 数据图表
import WarnTable from '../p_company/components/warnPage/warnTable.vue'; // 企业 告警中心 数据表格

import Cuser from '../p_company/components/systemPage/cuser.vue'; // 企业 系统中心 用户配置
import Crole from '../p_company/components/systemPage/crole.vue'; // 企业 系统中心 角色配置

import SiteDetection from '../p_company/components/sitePage/siteDetection.vue'; // 企业 站点模块 站点检测

import SiteDeploy from '../p_company/components/deployPage/siteDeploy.vue'; // 企业 配置模块 站点配置
import DeviceDeploy from '../p_company/components/deployPage/deviceDeploy.vue'; // 企业 配置模块 设备配置
import RtuDeploy from '../p_company/components/deployPage/rtuDeploy.vue'; // 企业 配置模块 rtu配置
import ConstraintDeploy from '../p_company/components/deployPage/constraintDeploy.vue'; // 企业 配置模块 约束规则配置
import ProcessDeploy from '../p_company/components/deployPage/processDeploy.vue'; // 企业 配置模块 工艺流程配置
//import PIDeploy from '../p_company/components/deployPage/piDeploy.vue'; // PI点位管理
import NoticeConfig from '../p_company/components/deployPage/noticeConfig.vue'; // 通知规则配置
import ActivCharcoDeploy from '../p_company/components/deployPage/activCharcoDeploy.vue'; // 企业 配置模块 活性炭配置
import AlarmDeploy from '../p_company/components/deployPage/AlarmDeploy.vue'; // 企业 配置模块 报警器配置

import Introduce from '../p_company/components/introducePage/introduce.vue'; // 企业 介绍模块

import Inspection from '../p_company/components/inspectionPage/inspection.vue'; // 企业 巡检模块 巡检
import WorkOrder from '../p_company/components/inspectionPage/workOrder.vue'; // 企业 巡检模块 工单

import Waste from '../p_company/components/eventPage/waste.vue'; // 企业 事件模块 废气废物排放

import ReplyInfo from '../p_company/components/infoPage/replyInfo.vue';
import OtherInfo from '../p_company/components/infoPage/otherInfo.vue';
import RewardInfo from '../p_company/components/infoPage/rewardInfo.vue';
import EvaluateInfo from '../p_company/components/infoPage/evaluateInfo.vue';
import ComplaintInfo from '../p_company/components/infoPage/complaintInfo.vue';
//危废管理
import SolidWasteAudit from '../p_company/components/waste/solidWasteAudit.vue'; // 固废管理
import records from '../p_company/components/waste/records.vue'; // 危废台账
import recordsSolid from '../p_company/components/waste/recordsSolid.vue'; // 固废台账
import statistics from '../p_company/components/waste/statistics.vue'; // 库存统计
import recordsCount from '../p_company/components/waste/recordsCount.vue'; // 出入库月统计
import recordsCountDay from '../p_company/components/waste/recordsCountDay.vue'; // 出入库日统计
import statisticsSolid from '../p_company/components/waste/statisticsSolid.vue'; // 库存统计
import recordsCountSolid from '../p_company/components/waste/recordsCountSolid.vue'; // 出入库月统计
import recordsCountDaySolid from '../p_company/components/waste/recordsCountDaySolid.vue'; // 出入库日统计
import request from '../p_company/components/waste/request.vue'; // 入库申请
import reminder from '../p_company/components/waste/reminder.vue'; // 提醒信息
import company from '../p_company/components/waste/company.vue'; // 危废企业管理
import typeManage from '../p_company/components/waste/typeManage.vue'; // 危废类型管理
import typeSolidManage from '../p_company/components/waste/typeSolidManage.vue'; // 一般固废类型管理
import faceLog from '../p_company/components/waste/faceLog.vue'; // 人脸日志

//数据统计
import bigDataCharts from '../p_company/components/bigData/bigDataCharts.vue'; // 大数据
import bigDataCharts1 from '../p_company/components/bigData/bigDataCharts1.vue'; // 大数据
import bigDataCharts2 from '../p_company/components/bigData/bigDataCharts2.vue'; // 大数据
import bigDataCharts3 from '../p_company/components/bigData/bigDataCharts3.vue'; // 大数据
import bigDataCharts4 from '../p_company/components/bigData/bigDataCharts4.vue'; // 大数据
import bigDataCharts5 from '../p_company/components/bigData/bigDataCharts5.vue'; // 大数据
//环境应急
import Contingency1 from '../p_company/components/contingency/contingency1.vue';
import Contingency2 from '../p_company/components/contingency/contingency2.vue';
import Contingency3 from '../p_company/components/contingency/contingency3.vue';
import ContingencyInfo from '../p_company/components/contingency/contingencyInfo.vue';
import KnowledgeBase from '../p_company/components/contingency/knowledgeBase.vue';
import ContingencySupplies from '../p_company/components/contingency/contingencySupplies.vue';
import EnvironmentalEmergencyPlan from '../p_company/components/contingency/environmentalEmergencyPlan.vue';

import FeedbackInfo from '../p_company/components/contingency/feedbackInfo.vue';
import Monitor from '../views/monitor.vue';

export default [
    {
        path: '/chome',
        name: 'chome',
        component: Chome,
        children: [
            {// 首页
                path: '/chome',
                name: 'map',
                component: MapHome
            },
            {// 报表图表
                path: '/chome/reportCharts',
                name: 'reportCharts',
                component: ReportCharts
            },
            {// 报表表格
                path: '/chome/reportTable',
                name: 'reportTable',
                component: ReportTable
            },
            {// 在线数据
                path: '/chome/onlineData',
                name: 'onlineData',
                component: OnlineData
            },
            {// 在线数据 - 污水出水
                path: '/chome/onlineDataWater1',
                name: 'onlineDataWater1',
                component: onlineDataWater1
            },
            {// 在线数据 - B区雨排口南
                path: '/chome/onlineDataWater2',
                name: 'onlineDataWater2',
                component: onlineDataWater2
            },
            {// 在线数据 - B区雨排口北
                path: '/chome/onlineDataWater3',
                name: 'onlineDataWater3',
                component: onlineDataWater3
            },
            {// 手工填报
                path: '/chome/manualInput',
                name: 'manualInput',
                component: ManualInput
            },
            // 报表日报
            {
                path: "/chome/reportDaily",
                name: "reportDaily",
                component: ReportDaily
            },
            {// 告警规则
                path: '/chome/warnRule',
                name: 'warnRule',
                component: WarnRule
            },
            {// 告警图表
                path: '/chome/warnCharts',
                name: 'warnCharts',
                component: WarnCharts
            },
            {// 告警表格
                path: '/chome/warnTable',
                name: 'warnTable',
                component: WarnTable
            },
            {// 用户配置
                path: '/chome/cuser',
                name: 'cuser',
                component: Cuser
            },
            {// 角色配置
                path: '/chome/crole',
                name: 'crole',
                component: Crole
            },
            {// 站点检测
                path: '/chome/siteDetection',
                name: 'siteDetection',
                component: SiteDetection
            },
            {// 站点配置
                path: '/chome/siteDeploy',
                name: 'siteDeploy',
                component: SiteDeploy
            },
            {// 设备配置
                path: '/chome/deviceDeploy',
                name: 'deviceDeploy',
                component: DeviceDeploy
            },
            {// rtu配置
                path: '/chome/rtuDeploy',
                name: 'rtuDeploy',
                component: RtuDeploy
            },
            {// 约束配置
                path: '/chome/constraintDeploy',
                name: 'constraintDeploy',
                component: ConstraintDeploy
            },
            // {
            //     path: '/chome/piDeploy',
            //     name: 'piDeploy',
            //     component: PIDeploy
            // },
            {
                path: '/chome/noticeConfig',
                name: 'noticeConfig',
                component: NoticeConfig
            },
            {// 活性炭配置
                path: '/chome/activCharcoDeploy',
                name: 'activCharcoDeploy',
                component: ActivCharcoDeploy
            },
            {// 报警器配置
                path: '/chome/alarmDeploy',
                name: 'alarmDeploy',
                component: AlarmDeploy
            },
            {// 站点介绍
                path: '/chome/introduce',
                name: 'introduce',
                component: Introduce
            },
            {// 巡检
                path: '/chome/inspection',
                name: 'inspection',
                component: Inspection
            },
            {// 工单
                path: '/chome/workOrder',
                name: 'workOrder',
                component: WorkOrder
            },
            {// 危废处理
                path: '/chome/waste',
                name: 'waste',
                component: Waste
            },
             {// 危废处理
                path: '/chome/replyInfo',
                name: 'replyInfo',
                component: ReplyInfo
            },
            {// 工艺流程
                path: '/chome/processDeploy',
                name: 'processDeploy',
                component: ProcessDeploy
            },
            
            {// 其他信息
                path: '/chome/otherInfo',
                name: 'otherInfo',
                component: OtherInfo
            },

            {// 环保奖惩
                path: '/chome/rewardInfo',
                name: 'rewardInfo',
                component: RewardInfo
            },

            {// 环保评价
                path: '/chome/evaluateInfo',
                name: 'evaluateInfo',
                component: EvaluateInfo
            },

             {// 环保评价
                path: '/chome/complaintInfo',
                name: 'complaintInfo',
                component: ComplaintInfo
            },
            //固废管理
            {
                path: '/waste/solidWasteAudit',
                name: 'solidWasteAudit',
                component: SolidWasteAudit
            },
            {
                path: '/waste/records',
                name: 'Records',
                component: records
            },
            {
                path: '/waste/recordsSolid',
                name: 'RecordsSolid',
                component: recordsSolid
            },
            {
                path: '/waste/statistics',
                name: 'Statistics',
                component: statistics
            },
            {
                path: '/waste/statisticsSolid',
                name: 'StatisticsSolid',
                component: statisticsSolid
            },
            {
                path: '/waste/recordsCount',
                name: 'RecordsCount',
                component: recordsCount
            },
            {
                path: '/waste/recordsCountSolid',
                name: 'RecordsCountSolid',
                component: recordsCountSolid
            },
            {
                path: '/waste/recordsCountDay',
                name: 'RecordsCountDay',
                component: recordsCountDay
            },
            {
                path: '/waste/recordsCountDaySolid',
                name: 'RecordsCountDaySolid',
                component: recordsCountDaySolid
            },
            {
                path: '/waste/request',
                name: 'Request',
                component: request
            },
            {
                path: '/waste/reminder',
                name: 'Reminder',
                component: reminder
            },
            {
                path: '/waste/company',
                name: 'Company',
                component: company
            },
            {
                path: '/waste/typeManage',
                name: 'TypeManage',
                component: typeManage
            },
            {
                path: '/waste/typeSolidManage',
                name: 'TypeSolidManage',
                component: typeSolidManage
            },
            {
                path: '/waste/faceLog',
                name: 'FaceLog',
                component: faceLog
            },
            {
                path: '/bigData/bigDataCharts',
                name: 'bigDataCharts',
                component: bigDataCharts
            },
            {// 大数据
                path: '/bigData/bigDataCharts1',
                name: 'bigDataCharts1',
                component: bigDataCharts1
            },
            {// 大数据
                path: '/bigData/bigDataCharts2',
                name: 'bigDataCharts2',
                component: bigDataCharts2
            },
            {// 大数据
                path: '/bigData/bigDataCharts3',
                name: 'bigDataCharts3',
                component: bigDataCharts3
            },
            {// 大数据
                path: '/bigData/bigDataCharts4',
                name: 'bigDataCharts4',
                component: bigDataCharts4
            },
            {// 大数据
                path: '/bigData/bigDataCharts5',
                name: 'bigDataCharts5',
                component: bigDataCharts5
            },
            {// 环境应急：应急响应流程
                path: '/chome/contingency1',
                name: 'contingency1',
                component: Contingency1
            },
            {// 环境应急：应急物资
                path: '/chome/contingency2',
                name: 'contingency2',
                component: Contingency2
            },
            {// 环境应急：应急物资分布图
                path: '/chome/contingency3',
                name: 'contingency3',
                component: Contingency3
            },
            {// 环境应急：应急演练信息
                path: '/chome/contingencyInfo',
                name: 'contingencyInfo',
                component: ContingencyInfo
            },
            {// 信息反馈
                path: '/chome/feedback',
                name: 'feedbackInfo',
                component: FeedbackInfo
            },
            {// 环保信息：知识库
                path: '/chome/knowledgeBase',
                name: 'knowledgeBase',
                component: KnowledgeBase
            },
            {// 环境应急：应急物资
                path: '/chome/contingencySupplies',
                name: 'contingencySupplies',
                component: ContingencySupplies
            },
            {// 环境应急：应急预案
                path: '/chome/environmentalEmergencyPlan',
                name: 'environmentalEmergencyPlan',
                component: EnvironmentalEmergencyPlan
            },
            {// 系统监控
                path: '/system/monitor',
                name: 'monitor',
                component: Monitor
            },
        ]
    }
]